import React from 'react';
import Content from '../dashboard/Content';
import TabPane from '../widgets/tab/TabPane';
import Tabs from '../widgets/tab/Tabs';
import DownloadExport from './DownloadExports';
import ExportTab from './ExportTab';

import './style';

const StoragePage: React.FC = () => {
  return (
    <Content title="ذخیره سازی">
      <div className="storage-page-cmp" style={{ paddingTop: '1rem' }}>
        <div className="row" style={{ height: '100%', maxHeight: 'calc(100% - 100px)' }}>
          <div className="col-11 mx-auto">
            <Tabs defaultActive="0">
              <TabPane key="0" text="پشتیبان گیری">
                <ExportTab />
              </TabPane>
              <TabPane key="1" text="دانلود اطلاعات">
                <DownloadExport />
              </TabPane>
            </Tabs>
          </div>
        </div>
      </div>
    </Content>
  );
};

export default StoragePage;
